import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { CountriesState } from '../../types';

import { getAvoidedCountries } from '../operations/getAvoidedCountries';

import { STATUS_LOADING } from 'common/constants';

export const setAvoidedCountries = (builder: ActionReducerMapBuilder<CountriesState>) => builder
  .addCase(getAvoidedCountries.pending, (state) => {
    state.avoidedCountries.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getAvoidedCountries.fulfilled, (state, { payload }) => {
    state.avoidedCountries.loadingStatus = STATUS_LOADING.done;
    state.avoidedCountries.data = payload;
  })
  .addCase(getAvoidedCountries.rejected, (state) => {
    state.avoidedCountries.loadingStatus = STATUS_LOADING.error;
  });
